type BrandProps = {
  footer?: boolean;
};

export function Brand({ footer = false }: BrandProps) {
  return (
    <a
      className={`brand${footer ? " brand-footer" : ""}`}
      href="/"
      aria-label="AIYSS トップへ"
    >
      <img
        className="brand-logo"
        src="/assets/images/logo_banner.png"
        alt="AIYSS"
      />
    </a>
  );
}
